import { Alert, Stack, Text } from '@mantine/core';
import { Info } from 'react-feather';
import type { CalendlyBookingHealth } from '../../types';
import { healthIssues } from './calendlyHealthIssues';

interface CalendlyBookingHealthAlertsProps {
  health: CalendlyBookingHealth | null | undefined;
  /** 'coach' speaks to the coach. 'admin' speaks about the coach. */
  audience: 'coach' | 'admin';
}

/** The notes for a coach's Calendly booking health. Renders nothing when all is well. */
export function CalendlyBookingHealthAlerts({
  health,
  audience,
}: CalendlyBookingHealthAlertsProps) {
  if (!health) return null;
  const issues = healthIssues(health, audience);
  if (issues.length === 0) return null;

  return (
    <Stack gap="xs">
      {issues.map(issue => (
        <Alert
          key={issue.key}
          color="blue"
          variant="light"
          icon={<Info size={16} />}
          title={issue.title ?? undefined}
          p="sm"
        >
          <Text size="xs">{issue.body}</Text>
          {issue.action && (
            <Text size="xs" fw={600} mt={4}>
              {issue.action}
            </Text>
          )}
        </Alert>
      ))}
    </Stack>
  );
}
